import { render, staticRenderFns } from "./cargo-block.vue?vue&type=template&id=79687475"
import script from "./cargo-block.vue?vue&type=script&lang=js"
export * from "./cargo-block.vue?vue&type=script&lang=js"
import style0 from "./cargo-block.vue?vue&type=style&index=0&id=79687475&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports